import type { Comment, NewComment } from "@/comments/types";
import { apiClient } from "./apiClient";

export const commentsGateway = {
  async getCommentsForHouse(houseId: number): Promise<Array<Comment>> {
    return await apiClient.get(`/api/comments/house/${houseId}`);
  },

  async createCommentForHouse(
    houseId: number,
    comment: NewComment,
  ): Promise<Comment> {
    return await apiClient.post(`/api/comments/house/${houseId}`, comment);
  },

  async deleteComment(comment: Comment): Promise<void> {
    await apiClient.delete(`/api/comments/${comment.id}`);
  },

  async updateComment(comment: Comment): Promise<void> {
    await apiClient.put(`/api/comments/${comment.id}`, comment);
  },
};
